// Import api models.
import {
	ComparisonSummaryEntity,
} from '@app/models/api';

export interface ComparisonSummaryEntitiesParameters<TEntityOld, TEntityNew = TEntityOld> {
	allowAdds: boolean;
	comparisonEntitySummaries: ComparisonSummaryEntity<TEntityOld, TEntityNew>[];
}

export default class ComparisonSummaryEntities<TEntityOld, TEntityNew = TEntityOld> {
	public allowAdds: boolean;
	public comparisonEntitySummaries: ComparisonSummaryEntity<TEntityOld, TEntityNew>[];

	public constructor(params: ComparisonSummaryEntitiesParameters<TEntityOld, TEntityNew>) {
		this.allowAdds = params.allowAdds;
		this.comparisonEntitySummaries = params.comparisonEntitySummaries;
	}

}